var map = {
	"./breakfast.jpg": 3264,
	"./check-partial.svg": 3160,
	"./check.svg": 535,
	"./garlic.jpg": 7538,
	"./ingredients.jpg": 8983,
	"./onion.jpg": 4036,
	"./pepper-flower.jpg": 2846,
	"./pepper.jpg": 1082,
	"./potato.jpg": 3992,
	"./tomato.jpg": 2778
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 990;